import { stringAttribute } from "../controller/attribute"

export const desktopWormholeContract = {
  activeAccountNumber: stringAttribute("tastyworksAccount"),
} as const
